import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { LoginService } from '../auth/services/login.service';
import { CambioModalComponent } from './modal/cambio-modal/cambio-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ColaboradoresModalComponent } from './modal/colaboradores-modal/colaboradores-modal.component';
import { MatriculacionAtajoModalComponent } from '../components/modales_atajos/matriculacion-atajo-modal/matriculacion-atajo-modal.component';
import { AyudaAtajoModalComponent } from '../components/modales_atajos/ayuda-atajo-modal/ayuda-atajo-modal.component';
import { DobleTrAtajoModalComponent } from '../components/modales_atajos/doble-tr-atajo-modal/doble-tr-atajo-modal.component';
import { BajaAtajoModalComponent } from '../components/modales_atajos/baja-atajo-modal/baja-atajo-modal.component';
import { FirmaDocumentosAtajoModalComponent } from '../components/modales_atajos/firma-documentos-atajo-modal/firma-documentos-atajo-modal.component';

@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.css'],
})
export class PageComponent implements OnInit {
  @ViewChild('sidenav') sidenav: MatSidenav;
  isExpanded = false;
  spinner: boolean;
  tipo: string;
  rol;
  colaborador: string;
  hide = false;

  constructor(
    private servicio: LoginService,
    public dialog: MatDialog,
    private router: Router
  ) {
    this.rol = sessionStorage.getItem('rol');
    if (this.rol === 'VENTAS' || this.rol === 'ROLE_SUPERADMIN' || this.rol === 'CONSULTA') {
      this.hide = true;
    }
    this.colaborador = sessionStorage.getItem('colaborador');
  }

  ngOnInit(): void {}

  logout(): void {
    this.servicio.logout();
  }

  toGo(): any {
    this.isExpanded = !this.isExpanded;
    sessionStorage.setItem('id', 'null');
    sessionStorage.setItem('tipoCliente', 'null');
    if (this.rol === 'GRUPO') {
      sessionStorage.setItem('colaborador', 'null');
    }
  }

  toGoCambio(): void {
    sessionStorage.setItem('id', 'null');
    if (this.rol === 'GRUPO') {
      sessionStorage.setItem('colaborador', 'null');
      const dialogRef = this.dialog.open(ColaboradoresModalComponent, {
        width: '400px',
        data: { colaborador: this.colaborador },
        hasBackdrop: true,
        disableClose: true,
        panelClass: 'custom-dialog',
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result !== undefined) {
          sessionStorage.setItem('colaborador', result.colaborador);
          sessionStorage.setItem('nifColaborador', result.nif);
          this.modalCambio();
        }
      });
    } else {
      this.modalCambio();
    }
  }

  toGoInforme(): void {
    sessionStorage.setItem('id', 'null');
    sessionStorage.setItem('tipoCliente', '1');
    if (this.rol === 'GRUPO') {
      sessionStorage.setItem('colaborador', 'null');
      const dialogRef = this.dialog.open(ColaboradoresModalComponent, {
        width: '400px',
        data: { colaborador: this.colaborador },
        hasBackdrop: true,
        disableClose: true,
        panelClass: 'custom-dialog',
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result !== undefined) {
          this.isExpanded = !this.isExpanded;
          sessionStorage.setItem('colaborador', result.colaborador);
          sessionStorage.setItem('nifColaborador', result.nif);
          this.router.navigate(['page/informe']);
        }
      });
    } else {
      this.isExpanded = !this.isExpanded;
      this.router.navigate(['page/informe']);
    }
  }

  toGoReduccion(): void {
    sessionStorage.setItem('id', 'null');
    if (this.rol === 'GRUPO') {
      console.log('Entro en Primer if', this.rol);
      sessionStorage.setItem('colaborador', 'null');
      const dialogRef = this.dialog.open(ColaboradoresModalComponent, {
        width: '400px',
        data: { colaborador: this.colaborador },
        hasBackdrop: true,
        disableClose: true,
        panelClass: 'custom-dialog',
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result !== undefined) {
          console.log('Entro en el segundo if', result);
          sessionStorage.setItem('colaborador', result.colaborador);
          sessionStorage.setItem('nifColaborador', result.nif);
          this.modalDobleCambio();
        } else {
          console.log('Entro en el segundo else ', result);
        }
      });
    } else {
      console.log('Entro en el primer else', this.rol);
      this.modalDobleCambio();
    }
  }

  toGoDistintivo(): void {
    sessionStorage.setItem('id', 'null');
    if (this.rol === 'GRUPO') {
      sessionStorage.setItem('colaborador', 'null');
      const dialogRef = this.dialog.open(ColaboradoresModalComponent, {
        width: '400px',
        data: { colaborador: this.colaborador },
        hasBackdrop: true,
        disableClose: true,
        panelClass: 'custom-dialog',
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result !== undefined) {
          this.isExpanded = !this.isExpanded;
          sessionStorage.setItem('colaborador', result.colaborador);
          sessionStorage.setItem('nifColaborador', result.nif);
          this.router.navigate(['page/distintivo']);
        }
      });
    } else {
      this.isExpanded = !this.isExpanded;
      this.router.navigate(['page/distintivo']);
    }
  }

  toGoJustificante(): void {
    sessionStorage.setItem('id', 'null');
    sessionStorage.setItem('tipoCliente', '1');
    if (this.rol === 'GRUPO') {
      sessionStorage.setItem('colaborador', 'null');
      const dialogRef = this.dialog.open(ColaboradoresModalComponent, {
        width: '400px',
        data: { colaborador: this.colaborador },
        hasBackdrop: true,
        disableClose: true,
        panelClass: 'custom-dialog',
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result !== undefined) {
          this.isExpanded = !this.isExpanded;
          sessionStorage.setItem('colaborador', result.colaborador);
          sessionStorage.setItem('nifColaborador', result.nif);
          this.router.navigate(['page/justificante']);
        }
      });
    } else {
      this.isExpanded = !this.isExpanded;
      this.router.navigate(['page/justificante']);
    }
  }

  toGoMatriculacion(): void {
    sessionStorage.setItem('id', 'null');
    if (this.rol === 'GRUPO') {
      sessionStorage.setItem('colaborador', 'null');
      const dialogRef = this.dialog.open(ColaboradoresModalComponent, {
        width: '400px',
        data: { colaborador: this.colaborador },
        hasBackdrop: true,
        disableClose: true,
        panelClass: 'custom-dialog',
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result !== undefined) {
          sessionStorage.setItem('colaborador', result.colaborador);
          sessionStorage.setItem('nifColaborador', result.nif);
          this.modalMatriculacion();
        }
      });
    } else {
      this.modalMatriculacion();
    }
  }

  modalMatriculacion(): void {
    const dialogRef = this.dialog.open(MatriculacionAtajoModalComponent, {
      width: '40%',
      data: { tipo: this.tipo },
      hasBackdrop: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.isExpanded = !this.isExpanded;
      console.log(result.value);
      sessionStorage.setItem('tipo', result.value.tipoTramite);
      sessionStorage.setItem('km', result.value.km);
      sessionStorage.setItem('paisOrigen', result.value.paisOrigen);
      this.router.navigate(['page/matriculacion']);
    });
  }

  modalAyudas(): void{
    sessionStorage.setItem('tipoCliente', '1');
    const dialogRef = this.dialog.open(AyudaAtajoModalComponent, {
      width: '40%',
      data: {tipo: this.tipo},
      hasBackdrop: true,

    });
    dialogRef.afterClosed().subscribe(result => {
      if(result !== undefined && result !== "") {
        console.log(result.value);
        sessionStorage.setItem('tipo', result.value.tipoTramite);
        sessionStorage.setItem('km', result.value.km);
        sessionStorage.setItem('paisOrigen', result.value.paisOrigen);
        sessionStorage.setItem('numPedido', result.value.numPedido);
        this.router.navigate(['page/ayudas']);
      }
    });
  }

  modalCambio(): void {
    const dialogRef = this.dialog.open(CambioModalComponent, {
      width: '40%',
      data: { tipo: this.tipo },
      hasBackdrop: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.isExpanded = !this.isExpanded;
      if (result !== undefined) {
        console.log(result.value);

        this.tipo = result.value.tipo;
        sessionStorage.setItem('numPedido', result.value.numPedido);
        sessionStorage.setItem('tipoTramite', result.value.tipoTramite);
        sessionStorage.setItem('justificante', result.value.justificante);
        if (this.tipo === '1') {
          sessionStorage.setItem('tipoCliente', '1');
          this.router.navigate(['page/cambio/vendedor']);
        }
        if (this.tipo === '2') {
          sessionStorage.setItem('tipoCliente', '2');
          this.router.navigate(['page/cambio/comprador']);
        }
        if (this.tipo === '3') {
          sessionStorage.setItem('tipoCliente', '3');
          this.router.navigate(['page/cambio/intermediario']);
        }
      } else {
        sessionStorage.setItem('tipoCliente', 'null');
        this.router.navigate(['page/home']);
      }
    });
  }

  modalDobleCambio(): void {
    console.log('Entro en la funcion modalDobleCambio');
    const dialogRef = this.dialog.open(DobleTrAtajoModalComponent, {
      width: '40%',
      data: { tipo: this.tipo },
      hasBackdrop: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result !== undefined) {
        this.isExpanded = !this.isExpanded;
        console.log('Entro en el if de modalDobleCambio', result.value);
        this.tipo = result.value.tipo;
        sessionStorage.setItem('numPedido', result.value.numPedido);
        sessionStorage.setItem('tipoTramite', result.value.tipoTramite);
        sessionStorage.setItem('tipoTramiteD', result.value.tipoTramiteD);
        sessionStorage.setItem('nroVentas', result.value.nroVentas);
        sessionStorage.setItem('baseImponible', result.value.baseImponible);
        sessionStorage.setItem('nroCompra', result.value.nroCompra);
        sessionStorage.setItem(
          'baseImponibleCompra',
          result.value.baseImponibleCompra
        );

        sessionStorage.setItem('tipoCliente', '3');
        this.router.navigate(['page/doble_transferencia']);
      }
    });
  }

  toGoBajas(): void {
    sessionStorage.setItem('id', 'null');
    if (this.rol === 'GRUPO') {
      sessionStorage.setItem('colaborador', 'null');
      const dialogRef = this.dialog.open(ColaboradoresModalComponent, {
        width: '400px',
        data: { colaborador: this.colaborador },
        hasBackdrop: true,
        disableClose: true,
        panelClass: 'custom-dialog',
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result !== undefined) {
          sessionStorage.setItem('colaborador', result.colaborador);
          sessionStorage.setItem('nifColaborador', result.nif);
          this.modalAtajoBaja();
        }
      });
    } else {
      this.modalAtajoBaja();
    }
  }

  toGoContactos(): void {
    sessionStorage.setItem('id', 'null');
    if (this.rol === 'GRUPO') {
      sessionStorage.setItem('colaborador', 'null');
      const dialogRef = this.dialog.open(ColaboradoresModalComponent, {
        width: '400px',
        data: { colaborador: this.colaborador },
        hasBackdrop: true,
        disableClose: true,
        panelClass: 'custom-dialog',
      });
      dialogRef.afterClosed().subscribe((result) => {
        console.log('Result', result);
        if (result !== undefined) {
          this.isExpanded = !this.isExpanded;
          sessionStorage.setItem('colaborador', result.colaborador);
          sessionStorage.setItem('nifColaborador', result.nif);
          sessionStorage.setItem('codigoColaborador', result.codigo);
          this.router.navigate(['page/contactos']);
        }
      });
    } else {
      this.isExpanded = !this.isExpanded;
      this.router.navigate(['page/contactos']);
    }
  }

  toGoAyudas(): void {
    sessionStorage.setItem('id', 'null');
    if (this.rol === 'GRUPO') {
      sessionStorage.setItem('colaborador', 'null');
      const dialogRef = this.dialog.open(ColaboradoresModalComponent, {
        width: '400px',
        data: { colaborador: this.colaborador },
        hasBackdrop: true,
        disableClose: true,
        panelClass: 'custom-dialog',
      });
      dialogRef.afterClosed().subscribe((result) => {
        console.log('Result', result);
        if (result !== undefined) {
          this.isExpanded = !this.isExpanded;
          sessionStorage.setItem('colaborador', result.colaborador);
          sessionStorage.setItem('nifColaborador', result.nif);
          sessionStorage.setItem('codigoColaborador', result.codigo);
          //this.router.navigate(['page/ayudas']);
          this.modalAyudas();
        }
      });
    } else {
      this.isExpanded = !this.isExpanded;
      //this.router.navigate(['page/ayudas']);
      this.modalAyudas();
    }
  }

  modalAtajoBaja(): void {
    const dialogRef = this.dialog.open(BajaAtajoModalComponent, {
      width: '40%',
      data: { tipo: this.tipo },
      hasBackdrop: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.isExpanded = !this.isExpanded;
      console.log(result.value);
      sessionStorage.setItem('tipo', result.value.tipo);
      sessionStorage.setItem('paisDestino', result.value.paisDestino);
      sessionStorage.setItem('numPedido', result.value.numPedido);
      this.router.navigate(['page/baja']);
    });
  }

  toGoFirmaDocumentos(): void {
    sessionStorage.setItem('id', 'null');
    if (this.rol === 'GRUPO') {
      sessionStorage.setItem('colaborador', 'null');
      const dialogRef = this.dialog.open(ColaboradoresModalComponent, {
        width: '400px',
        data: { colaborador: this.colaborador },
        hasBackdrop: true,
        disableClose: true,
        panelClass: 'custom-dialog',
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result !== undefined) {
          sessionStorage.setItem('colaborador', result.colaborador);
          sessionStorage.setItem('nifColaborador', result.nif);
          this.modalFirmaDocumentos();
        }
      });
    } else {
      this.modalFirmaDocumentos();
    }
  }

  modalFirmaDocumentos(): void {
    sessionStorage.setItem('tipoCliente', '1');
    const dialogRef = this.dialog.open(FirmaDocumentosAtajoModalComponent, {
      width: '40%',
      data: { tipo: this.tipo },
      hasBackdrop: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result !== undefined && result !== '') {
        this.isExpanded = !this.isExpanded;
        sessionStorage.setItem('tipo', 'FIRMA DOCUMENTOS');
        sessionStorage.setItem('mandato', result.value.mandato);
        sessionStorage.setItem('poder', result.value.poder);
        sessionStorage.setItem('tipoTramite', result.value.tramiteRelacionado);
        sessionStorage.setItem('numPedido', result.value.numPedido);
        this.router.navigate(['page/firma-documentos']);
      }
    });
  }
}
